import {
  Alert,
  Box, styled, TextField, Typography,
} from '@worthy-npm/worthy-common-ui-components';
import { IsMobileProp } from '../../../styles/commonPropType';
import { StepContainer } from '../../../styles/common';

const LabelTypography = styled(Typography)(() => ({
  fontFamily: 'Uncut Sans Variable',
  fontSize: '16px',
  lineHeight: '130%',
  fontWeight: 400,
  fontStyle: 'normal',
}));

const StyledTextField = styled(TextField)(({ theme }) => ({
  '& input': {
    padding: `${theme.spacing(2)} ${theme.spacing(1)}`,
  },
  '& .MuiInputBase-root.Mui-error': {
    color: theme.palette.error.main,
  },
}));

const DigitTextField = styled(StyledTextField)(({ theme }) => ({
  '& .MuiInputBase-root': {
    background: theme.palette.text.secondary,
    color: theme.palette.text.primary,
    display: 'flex',
    width: '48px',
    height: '53px',
    // padding: '15px 24px 16px 24px',
    padding: '0 auto',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '6px',
    border: '2px solid var(--Tritary, #73A0F7)',
    // fontSize: 32,
    textAlign: 'center',
    fontFamily: 'Uncut Sans Variable',
    fontWeight: 600,
    fontSize: '18px',
    lineHeight: '22px',
  },
  '&.digit-input-empty .MuiInputBase-root': {
    borderColor: 'var(--Secondary, #7A8994)',
  },
  '& .MuiInputBase-root.Mui-focused fieldset': {
    borderWidth: 0,
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderWidth: 0,
  },
}));

const LoginBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  outline: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(3),
  gap: theme.spacing(4),
  alignItems: 'center',
  [theme.breakpoints.down('sm')]: {
    outline: 'none',
    gap: theme.spacing(2),
    padding: theme.spacing(2),
  },
}));

const EmailBox = styled(Box)(() => ({
  padding: 0,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '32px',
}));

const StyledForm = styled('form')(({ theme }) => ({
  [theme.breakpoints.up('sm')]: {
    outline: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(3),
    gap: theme.spacing(4),
  },
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

const GoogleVerified = styled(Box) <IsMobileProp>`
    padding: 1rem 0;
    font-family: 'Roboto', serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 16px;
    color: #00bc35;
    text-align: center;
`;

const LogInContainer = styled('div')`
  display: flex;
  justify-content: center;
  min-height: 50px;
  align-items: center;
`;

const StepContainerTopAligned = styled(StepContainer)`
  justify-content: flex-start;
`;

const FooterIcon = styled('img')`
  margin: 0 8px;
`;

const StyledAlert = styled(Alert)(({ theme }) => ({
  fontWeight: 600,
  color: theme.palette.error.light,
  backgroundColor: 'transparent',
  '& .MuiAlert-icon': {
    color: theme.palette.error.light,
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(2),
    outline: `1px solid ${theme.palette.error.light}`,
    borderRadius: theme.shape.borderRadius,
    '& .MuiAlert-icon': {
      alignSelf: 'center',
    },
  },
}));
export {
  LabelTypography,
  DigitTextField,
  LoginBox,
  EmailBox,
  StyledForm,
  GoogleVerified,
  LogInContainer,
  StepContainerTopAligned,
  FooterIcon,
  StyledTextField,
  StyledAlert,
};
